var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "dialog-base",
    {
      attrs: {
        visible: _vm.visible,
        title: "Hướng dẫn thao tác khoản thu chính",
        size: "lg",
        "cancel-text": "Đóng",
        "confirm-text": "Đã hiểu",
        "use-panel": false,
        "append-to-body": true,
        top: "6vh",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        confirm: _vm.handleClose,
        cancel: _vm.handleClose,
      },
    },
    [
      _c("div", { staticClass: "trg-guide" }, [
        _c("div", { staticClass: "trg-section" }, [
          _c("p", { staticClass: "trg-title" }, [_vm._v("1) Thông tin chung")]),
          _c("ul", [
            _c("li", [
              _vm._v("Nhập "),
              _c("strong", [_vm._v("Tên khoản thu")]),
              _vm._v(", chọn "),
              _c("strong", [_vm._v("Loại khoản")]),
              _vm._v(" và "),
              _c("strong", [_vm._v("Đơn vị tính")]),
              _vm._v("."),
            ]),
            _c("li", [
              _vm._v("Mục "),
              _c("strong", [_vm._v("Mô tả")]),
              _vm._v(" dùng để ghi chú ngắn giúp dễ nhận diện khi quản lý."),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "trg-section" }, [
          _c("p", { staticClass: "trg-title" }, [
            _vm._v("2) Tài chính và công thức"),
          ]),
          _c("p", { staticClass: "trg-subtitle" }, [
            _vm._v("Trường hợp không áp dụng công thức"),
          ]),
          _c("ul", [
            _c("li", [
              _vm._v("Chọn "),
              _c("strong", [_vm._v("Không")]),
              _vm._v(" tại mục "),
              _c("strong", [_vm._v("Áp dụng công thức")]),
              _vm._v("."),
            ]),
            _c("li", [
              _vm._v("Nhập "),
              _c("strong", [_vm._v("Đơn giá")]),
              _vm._v(" và "),
              _c("strong", [_vm._v("Số lượng")]),
              _vm._v("."),
            ]),
            _c("li", [
              _vm._v("Nếu cần, bật "),
              _c("strong", [_vm._v("Giảm giá")]),
              _vm._v(" và chọn kiểu giảm phù hợp."),
            ]),
          ]),
          _c("p", { staticClass: "trg-example" }, [
            _vm._v(
              "Ví dụ: Đơn giá 2.000.000, số lượng 1, giảm 10% - thành tiền tham khảo còn 1.800.000."
            ),
          ]),
          _c("p", { staticClass: "trg-subtitle" }, [
            _vm._v("Trường hợp áp dụng công thức"),
          ]),
          _c("ul", [
            _c("li", [
              _vm._v("Chọn "),
              _c("strong", [_vm._v("Có")]),
              _vm._v(" tại mục "),
              _c("strong", [_vm._v("Áp dụng công thức")]),
              _vm._v("."),
            ]),
            _c("li", [
              _vm._v("Nhấn "),
              _c("strong", [_vm._v("Thêm biến")]),
              _vm._v(
                " để khai báo biến từ A-Z và chọn khoản thu gốc tương ứng."
              ),
            ]),
            _c("li", [_vm._v("Nhập biểu thức chỉ dùng các biến đã khai báo.")]),
            _c("li", [
              _vm._v("Chỉ dùng các phép toán "),
              _c("strong", [_vm._v("+")]),
              _vm._v(", "),
              _c("strong", [_vm._v("-")]),
              _vm._v(", "),
              _c("strong", [_vm._v("*")]),
              _vm._v(", "),
              _c("strong", [_vm._v("/")]),
              _vm._v(" và ngoặc "),
              _c("strong", [_vm._v("()")]),
              _vm._v("."),
            ]),
          ]),
          _c("p", { staticClass: "trg-example" }, [
            _vm._v("Ví dụ: A = Học phí, B = Tiền ăn, biểu thức "),
            _c("strong", [_vm._v("(A + B) * 0.9")]),
            _vm._v(" là giảm 10% trên tổng A và B."),
          ]),
        ]),
        _c("div", { staticClass: "trg-section" }, [
          _c("p", { staticClass: "trg-title" }, [
            _vm._v("3) Thuế và hóa đơn điện tử"),
          ]),
          _c("ul", [
            _c("li", [
              _vm._v("Nếu bật "),
              _c("strong", [_vm._v("Hóa đơn điện tử")]),
              _vm._v(", hệ thống sẽ tự yêu cầu bật "),
              _c("strong", [_vm._v("Khai báo thuế")]),
              _vm._v("."),
            ]),
            _c("li", [
              _vm._v("Khi chọn thuế "),
              _c("strong", [_vm._v("Khác")]),
              _vm._v(", cần nhập thêm phần trăm tại ô "),
              _c("strong", [_vm._v("Thuế khác (%)")]),
              _vm._v("."),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "trg-section" }, [
          _c("p", { staticClass: "trg-title" }, [
            _vm._v("4) Thời gian áp dụng"),
          ]),
          _c("ul", [
            _c("li", [
              _c("strong", [_vm._v("Theo tháng")]),
              _vm._v(
                ": chọn các tháng áp dụng, sau đó chọn cả tháng hoặc tùy chỉnh ngày."
              ),
            ]),
            _c("li", [
              _c("strong", [_vm._v("Theo khoảng ngày")]),
              _vm._v(": chọn ngày bắt đầu và kết thúc."),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "trg-section" }, [
          _c("p", { staticClass: "trg-title" }, [
            _vm._v("5) Cấu hình điểm danh"),
          ]),
          _c("ul", [
            _c("li", [
              _vm._v("Bật "),
              _c("strong", [_vm._v("Áp dụng điểm danh")]),
              _vm._v(
                " để chọn phương pháp tính, loại điểm danh và chi tiết tương ứng."
              ),
            ]),
            _c("li", [
              _vm._v("Với trường hợp "),
              _c("strong", [_vm._v("Đón muộn")]),
              _vm._v(
                ", cần nhập giờ đón về và cấu hình các khoảng thời gian tính phí."
              ),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "trg-note" }, [
          _vm._v(
            "Mẹo: Bạn vẫn có thể rê chuột vào từng biểu tượng dấu hỏi cạnh để xem giải thích nhanh tại chỗ."
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }